<app-st-banner [idVal]="'banner-id'" [breadCrumbs]="this.breadCrumbs"
               [hasElementTags]="false" [elementTags]="[]" [requiresSignOutButton]="true"
></app-st-banner>
<br><br><br><br>
<div class="container-xxl">
  <div class="row pt-4 pb5">
    <div class="col-2 d-flex justify-content-center neg-margin">
    </div>
    <div class="col-8">
      <app-st-breadcrumbs [crumbs]="breadCrumbs"></app-st-breadcrumbs>
      <app-st-header-title [inputVal]="profileName"></app-st-header-title>
    </div>
  </div>
  <div *ngIf="showMessages" class="container st-form text-danger" #goUp>
    <app-st-span><b>Please validate the following: </b></app-st-span>
    <div *ngFor="let errorMsg of messages" class="alert alert-danger" role="alert">
      <b>{{errorMsg.field}}:</b> {{errorMsg.detail}}
    </div>
    <br>
  </div>
  <div class="container st-form">
    <div class="col2 d-grid gap-2 d-md-flex justify-content-md-end align-items-end">
      <app-st-button-cancel [idVal]="'top-cancel-button-id'" [label]="'Cancel'" [primary]="false"
                            (click)="this.onCancel()"></app-st-button-cancel>
      <app-st-button [idVal]="'top-save-button-id'" [label]="'Submit'" [primary]="true"
                     (click)="this.onSave()"></app-st-button>
    </div>
    <br>
    <div class="row pt-2">
      <div class="col">
        <app-st-input-text [idVal]="'first-name-text-id'"
                           [label]="'*First Name'" [inputVal]="savedFirstName"
                           [placeHolderVal]="'First Name'"
                           [requiredVal]="true"
                           [maxLength]="40"
        ></app-st-input-text>
      </div>
      <div class="col">
        <app-st-input-text [idVal]="'last-name-text-id'"
                           [label]="'*Last Name'" [inputVal]="savedLastName"
                           [placeHolderVal]="'Last Name'"
                           [requiredVal]="true"
                           [maxLength]="40"
        ></app-st-input-text>
      </div>
    </div>
    <div class="row pt-2">
      <div class="col">
        <app-st-input-text-phone [idVal]="'phone-number-text-id'"
                           [label]="'*Phone Number: (Format: 1234567890)'" [inputVal]="savedPhoneNumber" [requiredVal]="true" [maxLength]="20"
        ></app-st-input-text-phone>
      </div>
    </div>
    <div class="row pt-2">
      <div class="col">
        <app-st-input-text-email [idVal]="'email-text-id'"
                                 [label]="'*Email'" [inputVal]="savedEmail" [requiredVal]="true" [disabled]="true"
                                 [maxLength]="40"
        >
        </app-st-input-text-email>
      </div>
    </div>

    <!--
    <div class="row pt-2">
      <div class="col">
        <app-st-input-text [idVal]="'address-line-1-text-id'"
                           [label]="'*Address Line 1'" [inputVal]="savedAddressLine1"
                           [disabled]="false"
                           [maxLength]="100"
        ></app-st-input-text>
      </div>
    </div>
    <div class="row pt-2">
      <div class="col">
        <app-st-input-text [idVal]="'address-line-2-text-id'"
                           [label]="'Address Line 2'" [inputVal]="savedAddressLine2"
                           [disabled]="false"
                           [maxLength]="100"
        ></app-st-input-text>
      </div>
    </div>
    <div class="row pt-2">
      <div class="col">
        <app-st-input-text [idVal]="'city-text-id'"
                           [label]="'*City'" [inputVal]="savedCity"
                           [disabled]="false"
                           [maxLength]="100"
        ></app-st-input-text>
      </div>
    </div>

    <app-st-span [inputVal]="'*State:'"></app-st-span><br>
    <app-st-select [idVal]="'usa-dropdown-list-id'" [defaultOption]="'Select State'" [label]="''" [idKey]="'usaStateId'" [displayKey]="'usaState'" [valueKey]="'usaState'" [inputArray]="this.statesList"></app-st-select>

    <div class="row pt-2">
      <div class="col">
        <app-st-input-text [idVal]="'country-text-id'"
                           [label]="'*Country'" [inputVal]="savedCountry"
                           [disabled]="false"
                           [maxLength]="50"
        ></app-st-input-text>
      </div>
    </div>
    <div class="row pt-2">
      <div class="col">
        <app-st-input-text [idVal]="'zip-code-text-id'"
                           [label]="'*Zip Code: (Formats: 12345, 123456789, or 12345-6789)'" [inputVal]="savedZipCode"
                           [disabled]="false"
                           [maxLength]="20"
        ></app-st-input-text>
      </div>
    </div>
    -->
    <br>
    <div class="row pt-2">
      <div class="col">
        <app-st-input-text [idVal]="'company-name-text-id'"
                           [label]="'*Company Name'" [inputVal]="savedCompanyName"
                           [disabled]="true"
                           [requiredVal]="true"
        ></app-st-input-text>
      </div>
    </div>
    <div class="row pt-2">
      <div class="col">
        <app-st-input-text [idVal]="'job-title-text-id'"
                           [label]="'*Job Title'" [inputVal]="savedJobTitle"
                           [disabled]="false"
                           [maxLength]="50"
        ></app-st-input-text>
      </div>
    </div>
    <div>
      <div class="row pt-2">
        <div class="col">
          <app-st-input-text  [idVal]="'username-text-id'"
                              [label]="'*Username'" [inputVal]="savedUsername"
                              [disabled]="true"
          ></app-st-input-text>
        </div>
      </div>
      <br><br>
    </div>
    <br>
    <app-st-button-back-to-top></app-st-button-back-to-top>
    <br>
    <br>
    <div *ngIf="showSuccessMessages" class="container st-messages-form text-success" #goUp>
      <app-st-span><b>Please validate the following: </b></app-st-span>
      <div *ngFor="let successMsg of successMessages" class="alert alert-success" role="alert">
        <b>{{successMsg.field}}:</b> {{successMsg.detail}}
      </div>
      <br>
    </div>
    <div *ngIf="showMessages" class="container st-messages-form text-danger" #goUp>
      <app-st-span><b>Please validate the following: </b></app-st-span>
      <div *ngFor="let errorMsg of messages" class="alert alert-danger" role="alert">
        <b>{{errorMsg.field}}:</b> {{errorMsg.detail}}
      </div>
      <br>
    </div>
    <br>
    <div class="col2 d-grid gap-2 d-md-flex justify-content-md-end align-items-end">
      <app-st-button-cancel [idVal]="'bottom-cancel-button-id'" [label]="'Cancel'" [primary]="false"
                            (click)="this.onCancel()"></app-st-button-cancel>
      <app-st-button [idVal]="'bottom-save-button-id'" [label]="'Submit'"
                     (click)="this.onSave()"></app-st-button>
    </div>
    <br>
    <br>
    <br>
  </div>
</div>


